import React from 'react';
import { Stack, Paper, Typography } from '@mui/material';
import { useGetCaseManagementQuery } from '../../../../services/CaseManagementService';
import { useSearchParams } from 'react-router-dom';
import { HistoryAndPhysicalField, ImagingReportField, ClinicalRecordsField, PhysicalTherapyNotesField, LabResultsField, PsychologicalEvaluationField, ClinicalReviewCommentsField, PolicyLinksField } from '../fieldEditors/caseMan/clinicalReview';
import { ClinicalReviewActions, ClinicalReviewStamp } from '../commands';

const ClinicalReviewTab: React.FC = () => {
  const [searchParams] = useSearchParams();
  const caseId = searchParams.get('id');
  
  const { data: caseData } = useGetCaseManagementQuery(
    { id: caseId! }, 
    { skip: !caseId }
  );
  const SECTION_PAPER_STYLE = {
    p: 2,
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: 1.5
  };

  return (
    <Stack spacing={4}>
      {/* Action Buttons and Status Stamp */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <ClinicalReviewActions />
        <ClinicalReviewStamp caseData={caseData} />
      </Stack>

      {/* Clinical Review Fields */}
      <Paper elevation={0} sx={SECTION_PAPER_STYLE}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 3 }}>
          Clinical Review Documentation
        </Typography>
        <Stack spacing={3}>
          <Stack direction="row" spacing={2}>
            <HistoryAndPhysicalField />
            <ImagingReportField />
            <ClinicalRecordsField />
          </Stack>
          <Stack direction="row" spacing={2}>
            <PhysicalTherapyNotesField />
            <LabResultsField />
            <PsychologicalEvaluationField />
          </Stack>
          <PolicyLinksField />
          <ClinicalReviewCommentsField />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default ClinicalReviewTab;
